import {filter, isNil, join, pipe} from 'ramda';
import {isNotNil, isNotNilOrEmpty} from 'ramda-adjunct';

import {LastActiveBusinessCaseResponseBody} from '@dms/api/finance';
import {SaleVehicleResponseBody} from '@dms/api/vehicle';
import i18n from '@dms/i18n';
import {businessCaseRoutes} from '@dms/routes';

import {buildArray, Nullish, composePath, OMISSION_STRING} from 'shared/web';

import {SnippetProps} from '../components/EntityHeader/components/EntityHeaderSnippet';
import {getBusinessCaseStateFlag} from './getBusinessCaseStateFlag';

export const getBusinessCaseSnippet = (
  saleVehicle: SaleVehicleResponseBody | Nullish,
  saleVehicleBC: LastActiveBusinessCaseResponseBody | Nullish,
  isVehicleAlreadySelling?: boolean
): Partial<SnippetProps> => {
  const shouldDisplayLastActiveBC =
    isNotNil(saleVehicleBC) && saleVehicleBC.businessCaseState !== 'UNSUCCESSFUL';

  if (isNil(saleVehicle) || !shouldDisplayLastActiveBC) {
    return {};
  }

  const isBuyingWidgetDisabled =
    (saleVehicle?.sellingState === 'sold' || isVehicleAlreadySelling) && !shouldDisplayLastActiveBC;
  const businessCaseStateFlag = getBusinessCaseStateFlag(saleVehicleBC?.businessCaseState);
  const ownerNameParts = [saleVehicleBC?.ownerFirstName, saleVehicleBC?.ownerLastName];
  const ownerName = pipe(
    filter(isNotNilOrEmpty),
    join(' '),
    (name) => `${i18n.t('entity.vehicle.labels.seller')}: ${name}`
  )(ownerNameParts);

  const title = saleVehicleBC?.customerName ?? saleVehicleBC?.id ?? '';
  const truncatedTitle = title.length > 22 ? title.slice(0, 22) + OMISSION_STRING : title;

  return {
    title: truncatedTitle,
    icon: 'places/business_center',
    href: composePath(businessCaseRoutes.overview, {
      params: {id: saleVehicleBC?.id},
      isSearchParamsPreserved: false,
    }),
    flags: isNotNil(businessCaseStateFlag) ? [businessCaseStateFlag] : undefined,
    isDisabled: isBuyingWidgetDisabled,
    parameters: buildArray<string>()
      .when(isNotNilOrEmpty(saleVehicleBC?.code), saleVehicleBC?.code ?? '')
      .add(ownerName),
  };
};
